import { Component } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';


/**
 * Custom Feature: Displays a US Official Website banner.
 */
@Component({
	selector: 'us-official-banner',
	templateUrl: './us-official-banner.component.html',
	styleUrls: [
		'./us-official-banner.component.css',
		'../../../../assets/vendor/usabanner/css/usabanner.css'
	]
})
export class UsOfficialBannerComponent implements AfterViewInit, OnDestroy {
	
    @ViewChild('bannerButton', { static: true }) bannerButton!: ElementRef;
    @ViewChild('bannerContent', { static: true }) bannerContent!: ElementRef;
    private clickHandler?: (event: Event) => void;
    private keyHandler?: (event: KeyboardEvent) => void;
	
	featureId: string = 'USOfficialWebsiteBanner';

    ngAfterViewInit(): void {
        this.setupBannerBehavior();
    }

    ngOnDestroy(): void {
        this.removeBannerBehavior();
    }

    private setupBannerBehavior(): void {
        if (!this.bannerButton || !this.bannerContent) return;

        const button = this.bannerButton.nativeElement;
        const content = this.bannerContent.nativeElement;

        this.clickHandler = (event: Event) => {
            event.preventDefault();
            this.toggleBanner();
        };

        this.keyHandler = (event: KeyboardEvent) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.toggleBanner();
            }
        };

        button.addEventListener('click', this.clickHandler);
        button.addEventListener('keydown', this.keyHandler);

        button.setAttribute('aria-expanded', 'false');
        content.setAttribute('hidden', '');
    }

    private removeBannerBehavior(): void {
        if (this.bannerButton && this.clickHandler) {
            const button = this.bannerButton.nativeElement;
            button.removeEventListener('click', this.clickHandler);
            if (this.keyHandler) {
                button.removeEventListener('keydown', this.keyHandler);
            }
        }
    }

    private toggleBanner(): void {
        const button = this.bannerButton.nativeElement;
        const content = this.bannerContent.nativeElement;
        
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const newExpanded = !isExpanded;
        
        button.setAttribute('aria-expanded', newExpanded.toString());
        
        if (newExpanded) {
            content.removeAttribute('hidden');
            content.style.display = 'block';
        } else {
            content.setAttribute('hidden', '');
            content.style.display = 'none';
        }
    }
}
